<template lang="pug">
content-preview-page(
  v-if='campaignContent',
  :description='campaign.description'
  :title='campaign.name',
  :content='campaignContent',
  :is-completed='campaign.status === "completed"'
)
</template>

<script>
import ContentPreviewPage from '@apps/Dymal/ContentEditor/ContentPreview.vue'
import state, { getCampaignById } from './store/campaigns.store'
import { setNavbuttonEnabled } from '@apps/Common/common.store'

export default {
  name: 'CampaignContentEditor',

  components: { ContentPreviewPage },

  computed: {
    campaign: () => state.campaign,
    campaignContent: () => state.campaign?.campaign_content,

    isCampaignEditable () {
      return ['draft', 'scheduled'].includes(this.campaign?.status)
    }
  },

  async created () {
    await getCampaignById(this.$route.params.id_campaign)

    if (!this.isCampaignEditable) {
      setNavbuttonEnabled(false)
    }
  },

  beforeDestroy () {
    setNavbuttonEnabled(true)
  }
}
</script>
